import { EditableText } from "eddev/blocks"
import { Card, CardTheme } from "./Card"
import { Button } from "./Button"

export const FeaturedCard = ({
  index,
  theme,
  title,
  subtitle,
  body,
  ctaText,
  hoverText,
  link,
}: {
  index: number
  theme?: CardTheme
  title: string
  subtitle: string
  body: string
  ctaText: string
  hoverText?: string
  link: string
}) => {
  return (
    <Card
      delay={150 + 150 * index}
      className="flex flex-col justify-between"
      theme={theme}
      activeChildren={
        <div className="w-full flex flex-col justify-between h-full">
          <EditableText
            store={`card${index}HoverText`}
            className="type-serif-lg-regular"
            defaultValue={hoverText || "Lorem ipsum dolor sit amet consectetur."}
            placeholder="Card hover text"
            as="p"
          />
          <Button variant="orange" href={link}>
            <EditableText store={`card${index}CtaText`} defaultValue={ctaText} placeholder="Card 1 CTA Text" as="p" />
          </Button>
        </div>
      }
    >
      <div className="flex flex-col gap-3 md:gap-2">
        <EditableText
          store={`card${index}Subtitle`}
          className="type-sans-sm-semibold"
          defaultValue={subtitle}
          placeholder="Card 1 Subtitle"
          as="p"
        />
        <EditableText
          store={`card${index}Title`}
          className="type-sans-2-xl-semibold"
          defaultValue={title}
          placeholder="Card 1 Title"
          as="p"
        />
      </div>
      <div className="w-full flex flex-col gap-7 md:gap-5">
        <EditableText
          store={`card${index}Body`}
          className="type-serif-base-regular text-pretty"
          defaultValue={body}
          placeholder="Card 1 Body"
          as="p"
        />
        <Button href={link}>
          <EditableText store={`card${index}CtaText`} defaultValue={ctaText} placeholder="Card 1 CTA Text" as="p" />
        </Button>
      </div>
    </Card>
  )
}
